export const INVENTORY_GET_ROLE = "pyctor.registry.inventory.get";
export const INVENTORY_POST_ROLE = "pyctor.registry.inventory.post";
